import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useLanguage } from "@/i18n";

export default function CookieConsent() {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);
  const [customizing, setCustomizing] = useState(false);
  const [analytics, setAnalytics] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("fx_consent")) setVisible(true);
    const open = () => {
      const c = JSON.parse(localStorage.getItem("fx_consent") || '{"analytics":false}');
      setAnalytics(!!c.analytics);
      setCustomizing(true);
      setVisible(true);
    };
    window.addEventListener("fx:open-cookie-preferences", open);
    return () => window.removeEventListener("fx:open-cookie-preferences", open);
  }, []);

  const save = (analyticsOn) => {
    localStorage.setItem("fx_consent", JSON.stringify({ necessary: true, analytics: analyticsOn, ts: Date.now() }));
    setVisible(false);
    setCustomizing(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] p-4" data-testid="cookie-banner">
      <div className="max-w-3xl mx-auto bg-ivory border border-stone2 shadow-xl p-6">
        <div className="flex items-start justify-between gap-4">
          <p className="text-sm text-ink/70 leading-relaxed" data-testid="cookie-text">{t("cookie_banner_text")}</p>
          <button onClick={() => save(analytics)} aria-label="Close" className="text-ink/40 hover:text-ink shrink-0" data-testid="cookie-close">
            <X size={16} strokeWidth={1.5} />
          </button>
        </div>
        {customizing && (
          <div className="mt-4 space-y-3 border-t border-stone2/50 pt-4" data-testid="cookie-preferences">
            <label className="flex items-center justify-between text-sm text-ink/70">
              <span>{t("cookie_necessary")}</span>
              <input type="checkbox" checked disabled className="w-4 h-4 accent-[#1D4E89]" />
            </label>
            <label className="flex items-center justify-between text-sm text-ink/70 cursor-pointer">
              <span>{t("cookie_analytics")}</span>
              <input
                type="checkbox"
                checked={analytics}
                onChange={(e) => setAnalytics(e.target.checked)}
                className="w-4 h-4 accent-[#1D4E89]"
                data-testid="cookie-analytics-toggle"
              />
            </label>
          </div>
        )}
        <div className="mt-5 flex flex-wrap gap-3">
          <button data-testid="cookie-accept-all" onClick={() => save(true)} className="bg-ink text-ivory text-[11px] font-medium uppercase tracking-[0.15em] px-5 py-3 hover:bg-medblue transition-colors duration-300">
            {t("cookie_accept_all")}
          </button>
          <button data-testid="cookie-reject" onClick={() => save(false)} className="border border-ink text-ink text-[11px] font-medium uppercase tracking-[0.15em] px-5 py-3 hover:bg-ink hover:text-ivory transition-colors duration-300">
            {t("cookie_reject")}
          </button>
          {customizing ? (
            <button data-testid="cookie-save" onClick={() => save(analytics)} className="border border-medblue text-medblue text-[11px] font-medium uppercase tracking-[0.15em] px-5 py-3 hover:bg-medblue hover:text-ivory transition-colors duration-300">
              {t("cookie_save_prefs")}
            </button>
          ) : (
            <button data-testid="cookie-customize" onClick={() => setCustomizing(true)} className="text-[11px] font-medium uppercase tracking-[0.15em] px-5 py-3 text-ink/60 hover:text-ink transition-colors duration-300">
              {t("cookie_customize")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
